import { useQuery } from '@tanstack/react-query';
import { apiDocumentServiceRepository } from '../../services/repositories/implementations/ApiDocumentServiceRepository';

export const useGetContentStyleByContentId = (contentId: string) => {
  return useQuery({
    queryKey: ['contentStyleSettings', contentId],
    queryFn: async () => await apiDocumentServiceRepository.getContentStyleSettings(contentId),
    staleTime: 5 * 60 * 1000,
    enabled: !!contentId,
  });
};
